module.exports = __webpack_public_path__ + "media/images/icons/resize-width-30bd03cb0b87798a28dccaad4ba22dc6.svg";